import QRCode from "react-qr-code";
import { CURRENCY, SERVICE_CODE, VIETQR } from "./vietqr";

// Component React
interface QRCodeComponentProps {
  amount: string | number;
  description: any;
  accountNumber: any;
}

export const QRCodeComponent: React.FC<QRCodeComponentProps> = ({
  amount,
  description,
  accountNumber,
}) => {
  // Initialize VIETQR instance
  const vietQRdata = new VIETQR();

  // Configure VIETQR fields
  vietQRdata.fields.is_dynamic_qr = true;
  vietQRdata.fields.merchant_category = "9999";
  vietQRdata.fields.amount = amount.toString();
  vietQRdata.fields.acq = "970448";
  vietQRdata.fields.merchant_id = accountNumber;
  vietQRdata.fields.service_code = SERVICE_CODE.TO_ACCOUNT;
  vietQRdata.fields.purpose_txn = description;
  vietQRdata.fields.currency = CURRENCY.VND;

  // Build VietQR data string
  const vietQRData = vietQRdata.builder();

  return (
    <div className="w-[200px] h-[200px] flex items-center justify-center">
      <QRCode
        value={vietQRData}
        size={200}
        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        viewBox={`0 0 200 200`}
        bgColor="#FFFFFF"
        fgColor="#000000"
        level="M" // Error correction level
      />
    </div>
  );
};
